export default "__VITE_ASSET__CbNyxHQ1__"